import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconPlayFrame16(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={16}
            height={16}
            className={customClassName}
            name="IconPlayFrame16"
            aria-hidden="true"
            {...props}
        >
            <path
                fill="currentColor"
                fillRule="evenodd"
                d="M13 3H3a1 1 0 0 0-1 1v1h12V4a1 1 0 0 0-1-1M2 12V6h12v6a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1M3 2a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V4a2 2 0 0 0-2-2zm4.554 4.95A1 1 0 0 0 6 7.783v3.357a1 1 0 0 0 1.536.845l2.582-1.64a1 1 0 0 0 .018-1.677zM7 7.783l2.582 1.718L7 11.14z"
                clipRule="evenodd"
            />
        </svg>
    );
}
export default memo(IconPlayFrame16);
